const OmanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112089)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20.0008C0 27.5817 4.21797 34.177 10.4348 37.569V2.43262C4.21797 5.82465 0 12.42 0 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M38.7561 26.9559C39.56 24.7893 40 22.4459 40 19.9995C40 17.553 39.56 15.2095 38.7561 13.043H1.24406C0.440078 15.2095 0 17.553 0 19.9995C0 22.4459 0.440078 24.7893 1.24406 26.9559L20 28.6951L38.7561 26.9559Z"
        fill="#D80027"
      />
      <path
        d="M19.9996 40.0005C28.599 40.0005 35.9297 34.573 38.7557 26.957H1.24365C4.06943 34.573 11.4004 40.0005 19.9996 40.0005Z"
        fill="#6DA544"
      />
      <path
        d="M0 19.9995C0 29.24 6.26727 37.0155 14.7826 39.3105V0.688477C6.26727 2.98348 0 10.7589 0 19.9995Z"
        fill="#D80027"
      />
      <path
        d="M12.2352 8.80164L10.3906 6.95703L9.16088 8.18688L7.93119 6.95703L6.08658 8.80164L7.31635 10.0314L6.08643 11.2612L7.93104 13.1059L9.1608 11.876L10.3906 13.1059L12.2352 11.2612L11.0054 10.0314L12.2352 8.80164Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112089">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default OmanSvg;
